import script from "./post.vue?vue&type=script&setup=true&lang=js"
export * from "./post.vue?vue&type=script&setup=true&lang=js"

import "./post.vue?vue&type=style&index=0&id=3aaafd11&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aaafd11"]])

export default __exports__